export enum TableViewContextType {
  FOLDER = 'FOLDER',
  GROUP = 'GROUP',
  SEARCH = 'SEARCH',
  EVISEARCH_SEARCH = 'EVISEARCH_SEARCH',
}
